import type { ProductWebhookDTO } from '../api/types';
import type { ProductWebhook } from '../model/types';

export const mapProductWebhook = (dto: ProductWebhookDTO): ProductWebhook => {
  return {
    id: dto.id,
    sourceIntegrationId: dto.sourceIntegrationId,
    productId: dto.productId,
    webhookPath: dto.webhookConfig.webhookPath,
    appHash: dto.webhookConfig.appHash,
    applicationIds: dto.webhookConfig.applicationIds,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
